export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.medilinensolutions.com'
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://medilinen.api.erpca.shop'
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000'
// export const API_BASE_URL = 'http://192.168.0.126:5000'